import React, { VFC } from 'react';
import styled from 'styled-components';
import Slider, { Settings } from 'react-slick';

import { useTheme } from '@material-ui/core/styles';
import { Image } from '~/models/Instagram/InstagramModel';
import { MEDIUM_IMAGE_SIZE, SMALL_IMAGE_SIZE } from '../constants';
import ImageLink from './ImageLink';

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface Props {
  images: Image[];
}
// 画像の表示のために細目にサイズの調整をしている
const SPAndTabletImagesComponent: VFC<Props> = ({ images }: Props) => {
  const theme = useTheme();
  const sliderSettings: Settings = {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: theme.breakpoints.values.lg,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 699,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const imageSize =
    window.innerWidth >= 375 ? MEDIUM_IMAGE_SIZE : SMALL_IMAGE_SIZE;

  return (
    <Slider {...sliderSettings} className="service-list-slick">
      {images.map((image) => (
        <div key={image.id}>
          <ImageWrapper>
            <ImageLink size={imageSize} image={image} />
          </ImageWrapper>
        </div>
      ))}
    </Slider>
  );
};

export default SPAndTabletImagesComponent;
